import { v4 as uuidv4 } from 'uuid';
export class EngagementActivityDocModel {
    constructor() {
        this.id = uuidv4();
        this.activityId = null;
        this.description = '';
        this.url = '';
    }
}
export default class EngagementActivityDoc extends EngagementActivityDocModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
